import CurrencyratePage, {
  CurrencyratePageFormData
} from "@saleor/currencyrate/components/CurrencyratePage";
import { useCurrencyrateCreateMutation } from "@saleor/currencyrate/mutations";
import {
  CurrencyrateAddUrlQueryParams,
  currencyrateListUrl,
  currencyrateUrl
} from "@saleor/currencyrate/urls";
import useNavigator from "@saleor/hooks/useNavigator";
import useNotifier from "@saleor/hooks/useNotifier";
import React from "react";
import { useIntl } from "react-intl";

interface CurrencyrateDetailsProps {
  params: CurrencyrateAddUrlQueryParams;
}

const CurrencyratDetails: React.FC<CurrencyrateDetailsProps> = ({}) => {
  const navigate = useNavigator();
  const notify = useNotifier();
  const intl = useIntl();

  const [
    currencyrateCreate,
    currencyrateCreateOpts
  ] = useCurrencyrateCreateMutation({
    onCompleted: data => {
      if (data.currencyrateCreate.errors.length === 0) {
        notify({
          status: "success",
          text: intl.formatMessage({
            defaultMessage: "Successfully created currencyrate"
          })
        });
        navigate(currencyrateUrl(data.currencyrateCreate.currencyrate.id));
      }
    }
  });

  const handleSubmit = async (data: CurrencyratePageFormData) => {
    const input = {
      ...data
    };
    const result = await currencyrateCreate({
      variables: {
        input
      }
    });
    return result.data.currencyrateCreate?.currencyrate?.id || null;
  };
  return (
    <>
      <CurrencyratePage
        currencyrate={null}
        disabled={currencyrateCreateOpts.loading}
        errors={currencyrateCreateOpts.data?.currencyrateCreate.errors || []}
        onBack={() => navigate(currencyrateListUrl())}
        onDelete={undefined}
        onSubmit={handleSubmit}
        saveButtonBarState={currencyrateCreateOpts.status}
        title={"add"}
      ></CurrencyratePage>
    </>
  );
};

export default CurrencyratDetails;
